<template>
  <div>
    <top />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'nuxt-property-decorator';

import HeaderAnnouncement from '@/components/common/header-announcement.vue';
import TrialRegistrationDialog from '@/components/dialog/trial-registration-dialog.vue';
import TopBanner from '@/components/top-banner.vue';
import Top from '@/components/renewal/top.vue';
import 'design-system/tokens';

@Component({
  components: {
    HeaderAnnouncement,
    TrialRegistrationDialog,
    TopBanner,
    Top,
  },
})
export default class Index extends Vue {
  /** お知らせ */
  announcement: { title: string; url: string } | null = null;

  mounted(): void {
    this.$repositories.announcement.getAnnouncement().then((res) => (this.announcement = res));
  }
}
</script>

<style lang="scss">
@import '@/../node_modules/vuetify/src/styles/styles.sass';
</style>
